import React, { useEffect, useState } from 'react';
import { Box, CardMedia, CircularProgress } from '@mui/material';
import { getFileUploadUrl } from '../../project/project.api';
import { handleError } from '../../../common/utils/util.errors';

interface PreviewImageProps {
  blobName: string | null;
  onClick?: () => void;
  alt?: string;
  sx?: object;
  fallbackText?: string;
}

const PreviewImage: React.FC<PreviewImageProps> = ({ blobName, onClick, alt = '', sx = {} }) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    const fetchBlobUrl = async () => {
      if (!blobName) {
        setImageUrl(null);
        return;
      }
      try {
        const url = await getFileUploadUrl(blobName);
        setImageUrl(url);
        setIsImageLoaded(false);
      } catch (error) {
        handleError(error);
        setImageUrl(null);
      }
    };
    fetchBlobUrl();
  }, [blobName]);

  if (!blobName || !imageUrl) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', bgcolor: 'white' }}></Box>;
  }

  return (
    <>
      {!isImageLoaded && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <CircularProgress />
        </Box>
      )}
      <CardMedia
        component='img'
        image={imageUrl}
        onLoad={() => setIsImageLoaded(true)}
        onClick={onClick}
        alt={alt}
        sx={{ width: '100%', height: '100%', objectFit: 'cover', margin: 0, display: isImageLoaded ? 'block' : 'none', ...sx }}
      />
    </>
  );
};

export default PreviewImage;
